// assets
import { 
    IconFileText, 
    IconReceipt,
    IconId,
    IconTrafficLights,
    IconStars,
    IconBox,
    IconKeyboard
} from '@tabler/icons';

// constant
export const icons = {
    IconFileText,
    IconReceipt,
    IconId,
    IconTrafficLights,
    IconStars,
    IconBox,
    IconKeyboard
};

const searchEngineCanada = {
    id: 'search-engine-canada',
    title: 'side_menu.search_engine_canada',
    type: 'group',
    roles: ['accesscanada'],
    collapse: false,
    children: [
        {
            id: 'by-giving-history-ca',
            title: 'side_menu.by_giving_history',
            type: 'item',
            url: 'main/search/giving-history-ca',
            icon: 'IconFileText', //icons.IconFileText,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'by-name',
            title: 'side_menu.by_name',
            type: 'item',
            url: 'main/search/name-ca',
            icon: 'IconReceipt', //icons.IconReceipt,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'by-director',
            title: 'side_menu.by_director',
            type: 'item',
            url: 'main/search/directors-ca',
            icon: 'IconId', //icons.IconId,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        {
            id: 'by-year',
            title: 'side_menu.by_year',
            type: 'item',
            url: 'main/search/year-ca',
            icon: 'IconTrafficLights', //icons.IconTrafficLights,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        /*{
            id: 'by-rating',
            title: 'side_menu.by_rating',
            type: 'item',
            url: 'main/search/by-rating',
            icon: icons.IconStars,
            breadcrumbs: false,
            roles: ['user', 'subuser'],
        },*/
        {
            id: 'by-custom',
            title: 'side_menu.by_custom',
            type: 'item',
            url: 'main/search/by-custom-v2',
            icon: 'IconBox', //icons.IconBox,
            breadcrumbs: false,
            roles: ['user', 'subuser', 'member', 'supervisor', 'admin', 'demo', 'sales', 'superadmin', 'it'],
        },
        
    ]
};

export default searchEngineCanada;